import React from 'react';

import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { imgUrl } from '~src/commonInfra/utils/ImgUrl';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';

import { Messages } from '../../../codegen/Localize';
import { classes, cssClass } from '../../../style';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';

const cssPrefix = 'LensThumbnail';

const rootClass = cssClass(cssPrefix, 'root', {
  color: 'inherit',
  textDecoration: 'none',
  $nest: {
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    }
  }
});

const getIconClass = () => cssClass(cssPrefix, 'icon', {
  // TODO: change thumbnail image for lens thumbnail
  backgroundImage: imgUrl('spaces_masthead_lens.svg')
});

export type LensThumbnailProps = SiteUrlsProps & Pick<React.AriaAttributes, 'aria-label'> & {
  readonly navigateUrl: string;
  readonly owner: IUserInfo;
  readonly hovered?: boolean;
  readonly selected?: boolean;
}

export class LensThumbnail extends React.Component<LensThumbnailProps> {

  public render() {
    return (
      <a className={classes(rootClass, CardViewStyles.ThumbnailFocus, CardViewStyles.CustomThumbnail, {
          [CardViewStyles.SelectedClassName]: this.props.selected,
          [CardViewStyles.HoveredClassName]: this.props.hovered && !this.props.selected
        })}
         href={this.props.navigateUrl}
         aria-label={this.props['aria-label']}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={classes(CardViewStyles.CustomThumbnailImg, getIconClass())} title={Messages.lens()} />
          </div>
        </div>
      </a>
    );
  }
}
